import React from 'react';

const Landingpage: React.FC = () => {
  return (
    <div className="landing-page">
      {/* Header */}
      <header className="bg-primary text-white py-3">
        <div className="container d-flex justify-content-between align-items-center">
          <img src="/assets/images/logo-inplay.svg" alt="InPlay" height="40" />
            <button
            className="btn btn-secondary text-white"
            onClick={() => window.location.href = '/home'}
            >
            ACESSAR CONTA
            </button>
        </div>
      </header>

      {/* Hero */}
      <section
        className="hero-section d-flex flex-column justify-content-center align-items-center text-center text-white"
        style={{
          backgroundImage: 'url("assets/images/banner.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          aspectRatio: '16 / 9',
        }}
      >
        <img src="/assets/images/login-banner.png" alt="InPlay" className="mb-4" style={{ maxWidth: '200px' }} />
        <h1 className="fw-bold px-3">A MELHOR OPÇÃO para disputar e gerenciar torneios de Beach Tennis.</h1>
      </section>

      {/* Session 1 */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 mb-4 mb-md-0">
              <h2>Interaja com outros atletas</h2>
              <p>
                Compartilhe seus resultados e estatísticas com a comunidade, ou compartilhe as mais novas
                atualizações do mundo do Beach Tennis.
              </p>
              <button className="btn btn-primary text-white mt-2" onClick={() => window.location.href = '/register'}>Comece agora →</button>
            </div>
            <div className="col-md-6 text-center">
              <img src="assets/images/notebook.png" alt="Notebook" className="img-fluid" />
            </div>
          </div>
        </div>
      </section>

      {/* Session 2 */}
      <section className="py-5 text-white bg-primary">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 mb-4 mb-md-0 order-md-2 text-center">
              <img src="assets/images/login-banner.png" alt="Login" className="img-fluid" />
            </div>
            <div className="col-md-6 order-md-1">
              <h2>Jogar beach nunca foi tão fácil!</h2>
              <p>
                Listagem de jogos, postagens em feed, relatórios e centenas de outras oportunidades, em um só lugar.
              </p>
              <button className="btn btn-tertiary text-white mt-2" onClick={() => window.location.href = '/register'}>Comece agora →</button>
            </div>
          </div>
        </div>
      </section>

      {/* Session 3 */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 mb-4 mb-md-0">
              <h2>Crie o seu torneio</h2>
              <p>
                Opções de criação e manutenção dos seus torneios. Com o InPlay você consegue organizar todos os
                detalhes da competição em poucos minutos.
              </p>
              <button className="btn btn-primary text-white mt-2" onClick={() => window.location.href = '/register'}>Comece agora →</button>
            </div>
            <div className="col-md-6 text-center">
              <img src="assets/images/notebook-celular.png" alt="Notebook" className="img-fluid" />
            </div>
          </div>
        </div>
      </section>

      {/* Session 4 */}
      <section className="py-5 text-white bg-primary">
        <div className="container text-center">
          <h2 className="mb-3">Não tem porque complicar!</h2>
          <p>
            Além de útil, o InPlay facilita a vida de quem está organizando ou simplesmente quer participar de
            torneios. Tudo isso dentro da sua própria casa, na palma da sua mão.
          </p>
          <button className="btn btn-tertiary text-white mt-2" onClick={() => window.location.href = '/register'}>Comece agora →</button>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-5 bg-white">
        <div className="container text-center">
          <h2 className="mb-5 text-black">Comentários de quem usa</h2>
          <div className="row g-4">
            <div className="col-md-4">
              <div className="p-4 border rounded h-100 d-flex flex-column">
                <p className="flex-grow-1">
                  "Organizar torneios ficou muito mais simples. Em poucos minutos consigo montar chaves, 
                  gerenciar inscrições e acompanhar resultados em tempo real. Recomendo demais!"
                </p>
                <hr />
                <div className="d-flex align-items-center">
                  <img src="assets/images/user.png" alt="Avatar" className="rounded-circle me-3" width="48" height="48" />
                  <div className="text-start">
                    <div className="fw-bold">Ricardo Mendes</div>
                    <small className="text-muted">Organizador de torneios</small>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="p-4 border rounded h-100 d-flex flex-column">
                <p className="flex-grow-1">
                  "Uso o InPlay toda semana pra reservar quadra com os amigos. O processo de agendamento 
                  é super rápido e o pagamento pelo app facilita muito. Nunca mais perdi horário!"
                </p>
                <hr />
                <div className="d-flex align-items-center">
                  <img src="assets/images/user.png" alt="Avatar" className="rounded-circle me-3" width="48" height="48" />
                  <div className="text-start">
                    <div className="fw-bold">Camila Oliveira</div>
                    <small className="text-muted">Jogadora de Beach Tennis</small>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="p-4 border rounded h-100 d-flex flex-column">
                <p className="flex-grow-1">
                  "A parte social do app é incrível. Consigo acompanhar resultados dos meus amigos, 
                  ver rankings e ainda ficar por dentro dos próximos torneios da região."
                </p>
                <hr />
                <div className="d-flex align-items-center">
                  <img src="assets/images/user.png" alt="Avatar" className="rounded-circle me-3" width="48" height="48" />
                  <div className="text-start">
                    <div className="fw-bold">Fernando Costa</div>
                    <small className="text-muted">Atleta amador</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-primary text-white pt-5 pb-3">
        <div className="container text-center">
          <h2 className="mb-3">Facilite a sua gestão ainda hoje!</h2>
          <p>Comece de graça! Crie uma conta, é rápido e fácil.</p>
          <button className="btn btn-tertiary text-white mb-4" onClick={() => window.location.href = '/register'}>Comece agora →</button>
          <div className="mb-4">
            <img src="assets/images/logo-inplay.svg" alt="InPlay" height="40" />
          </div>
          <div className="d-flex justify-content-between align-items-center flex-column flex-md-row">
            <div>
              <a href="/termos-de-uso" className="text-white me-2">Termos de uso</a>
              <span className="d-block d-md-inline">© InPlay 2026</span>
            </div>
            <div className="mt-2 mt-md-0">
              <a href="#" className="text-white me-2"><i className="bi bi-facebook"></i></a>
              <a href="#" className="text-white me-2"><i className="bi bi-instagram"></i></a>
              <a href="#" className="text-white"><i className="bi bi-twitter-x"></i></a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Landingpage;
